import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import useStyles from "./FmRadioButton.style";
import { useTranslation } from "react-i18next";

interface FmRadioButtonProps {
    title?: string;
    values: any;
    onChange: any;
    noMarginStart?: boolean;
    defaultValueIndex?: number;
    gap?: number;
    getDataLabel?: (item: any) => string;
    getDataValue?: (item: any) => string;
}

const FmRadioButton = React.forwardRef(
    ({ gap = 0, onChange, values, title, noMarginStart, getDataLabel, getDataValue, defaultValueIndex }: FmRadioButtonProps, ref) => {
        const classes = useStyles();
        const { t } = useTranslation();
        const onGetDataLabel = (item: any) => (getDataLabel ? getDataLabel(item) : item);
        const onGetDataValue = (item: any) => (getDataValue ? getDataValue(item) : item);

        return (
            <div className={noMarginStart ? classes.container_noMargin : classes.container} style={{ gap }}>
                <div className={classes.label}>{title}</div>
                <FormControl component='fieldset'>
                    <RadioGroup
                        row
                        aria-label='radio'
                        name='row-radio-buttons-group'
                        onChange={onChange}
                        defaultValue={values && values.length > 0 ? onGetDataValue(values[defaultValueIndex ? defaultValueIndex : 0]) : undefined}
                    >
                        {values &&
                            values.map((v: any) => (
                                <FormControlLabel
                                    inputRef={ref}
                                    key={onGetDataValue(v)}
                                    value={onGetDataValue(v)}
                                    control={<Radio />}
                                    label={onGetDataLabel(v)}
                                />
                            ))}
                    </RadioGroup>
                </FormControl>
            </div>
        );
    }
);

export default FmRadioButton;
